var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOtros = function SvgOtros(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.508 2.519a.7.7 0 0 0-1.016 0l-9 9.5a.7.7 0 0 0-.192.481V22a.7.7 0 0 0 .7.7h18a.7.7 0 0 0 .7-.7v-9.5a.7.7 0 0 0-.192-.481l-9-9.5ZM3.7 21.3v-8.521L12 4.018l8.3 8.76V21.3H3.7Zm8.3-11a.7.7 0 0 1 .7.7v.1a.7.7 0 1 1-1.4 0V11a.7.7 0 0 1 .7-.7Zm0 3a.7.7 0 0 1 .7.7v4a.7.7 0 1 1-1.4 0v-4a.7.7 0 0 1 .7-.7Z",
    clipRule: "evenodd"
  })));
};
export default SvgOtros;